export function rawToDashed(raw: string) {
  return raw.replace(/::/g, '-');
}

export function dashedToRaw(dashed: string) {
  return dashed.replace(/-/g, '::');
}
